module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-with-us"
  }, [_c('h5', [_vm._v("Kontakt")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v("partnerzy@punkta.pl")]), _vm._v(" "), _c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://dokumenty.punkta.pl/Regulamin-Programu-Partnerskiego-Punkta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Regulamin")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0433eb0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact.vue
// module id = 356
// module chunks = 0